import { useTipoObraCard } from "./use-tipo-obra-card";
import { TipoObraCardView } from "./view-tipo-obra-card";
import type { TipoObraCardProps } from "./types-tipo-obra-card";

export function TipoObraCard(props: TipoObraCardProps) {
  const vm = useTipoObraCard(props);

  return <TipoObraCardView {...props} {...vm} />;
}

export type * from "./types-tipo-obra-card";
